import { logWrapper } from '../../utils';

export default {
  previewService: [
    'runtimeConstant',
    '$rootScope',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    function (runtimeConstant, $rootScope, $http, $q, $filter, webApiSettings) {
      'use strict';

      function previewDocument(revision) {
        return $http.post(
          `${webApiSettings.apiServiceBaseUri}preview/`,
          revision,
          {
            responseType: 'arraybuffer'
          }
        );
      }

      function run() {
        try {
          var previewServiceFactory = {};

          previewServiceFactory.previewDocument = logWrapper(
            previewDocument,
            runtimeConstant.isDebugServicesInternals
          );

          return previewServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
